import {KhachHangModelLite } from './../../../dung-chung/__model/common_config.model';
import { select } from '@ngrx/store';
import {Component,
		OnInit,
		ElementRef,
		ViewChildren,
		ViewChild,
		ChangeDetectionStrategy,
		ChangeDetectorRef,
		Inject,
		HostListener,
		ViewRef
	}
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { KhachHangService } from '../../../danh-muc/khach-hang/khach-hang-service/khach-hang.service';

import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { CommonConFig, NhaCungCapModelLite } from '../../../dung-chung/__model/common_config.model';
import { KdYeuCauBaoGiaService } from '../kd-yeu-cau-bao-gia-service/kd-yeu-cau-bao-gia.service';
import moment from 'moment';

@Component({
	selector: 'm-them-moi-kh',
	templateUrl: './them-moi-kh.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class ThemMoiKHComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;

	/* Các trường focus cho các tag trong form */
	@ViewChildren('focusTKH') focusTKH;
	@ViewChildren('focusLKH') focusLKH;
	@ViewChildren('focusDT') focusDT;
	@ViewChildren('focusNLH') focusNLH;
	@ViewChildren('focusDC') focusDC;
	@ViewChildren('focusT') focusT;

	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;

	/* Mat select search cho khach hang */
	listListLoaiKH : any[] = [];
	selectListLoaiKH : string = '';
	filteredListLoaiKH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListLoaiKHFilterCtrl: string = '';
	haveElementListLoaiKH: boolean = false;
	viewLoading = false;
	
	listListTinh : any[] = [];
	selectListTinh : string = '';
	filteredListTinh: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListTinhFilterCtrl: string = '';
	haveElementListTinh: boolean = false;

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	isChange: boolean = false;
	dataRespone: number = 0;
	ThemKH: FormGroup;		
	category_path='KH';
	//#region Phím tắt
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode){
			this.back();
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.LUU.KeyCombine.keycode) {
			this.onSubmit();
		}
	}
	//#endregion Phím tắt

	constructor(
		public 	dialogRef2: MatDialogRef<ThemMoiKHComponent>,
		private DungChungService: DungChungService,
		private kdYCBGService: KdYeuCauBaoGiaService,
		public 	dialog2: MatDialog,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private ThemKHFB: FormBuilder,
		private el: ElementRef,
		
	) {}

	//#region Load Data
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.ListLoaiKH(); 
		this.ListTinh();
		this.createForm();
		this.createAutoKH();
		this.changeDetect.detectChanges();
	}

	ngAfterViewInit() {
		// setTimeout(() => {
		// 	setTimeout(() => this.focusTKH.first.nativeElement.focus(), 0);
		// }, 0);
		this.changeDetect.detectChanges();
	}
	//#endregion Load Data

	//#region Lấy danh sách
	async ListLoaiKH(){
		const res = await this.DungChungService.listLoaiKH().toPromise();
		if (res && res.status === 1) {
			this.listListLoaiKH = res.data;
			if(this.listListLoaiKH.length > 0) this.ThemKH.controls['LOAIKH'].setValue(''+this.listListLoaiKH[0].Id_LoaiKH);
			this.filteredListLoaiKH.next(this.listListLoaiKH.slice());
			this.changeDetect.detectChanges();
		};
	}

	filterListLoaiKH() {
		if (!this.listListLoaiKH) {
			return;
		}
		// get the search keyword
		let search = this.ListLoaiKHFilterCtrl;
		if (!search) {
			this.filteredListLoaiKH.next(this.listListLoaiKH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListLoaiKH.next(
			this.listListLoaiKH.filter(ts =>
				ts.TenLoaiKH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}

	async ListTinh(){
		const res = await this.DungChungService.listTinh().toPromise();
		if (res && res.status === 1) {
			this.listListTinh = res.data;
			if(this.listListTinh.length > 0) this.ThemKH.controls['TINH'].setValue(''+this.listListTinh[0].Id_Tinh);
			this.filteredListTinh.next(this.listListTinh.slice());
			this.changeDetect.detectChanges();
		};
	}

	filterListTinh() {
		if (!this.listListTinh) {
			return;
		}
		let search = this.ListTinhFilterCtrl;
		if (!search) {
			this.filteredListTinh.next(this.listListTinh.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListTinh.next(
			this.listListTinh.filter(ts =>
				ts.TenTinh.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	//#endregion Lấy danh sách

	//#region Quay về
	back(){
		this.dialogRef2.close({
			isChange: this.isChange,
			dataAdd : this.dataRespone
		});
	}
	//#endregion Quay về

	//#region Tạo form
	async createForm(){
		this.ThemKH = this.ThemKHFB.group({
			MAKH: ['', Validators.required],
			TENKH: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
			NGUOIDAIDIEN: ['',Validators.compose([Validators.required,Validators.maxLength(200)])],
			DIENTHOAI: ['',Validators.compose([Validators.required, Validators.pattern('^(((09|03|07|08|05)+([0-9]{8}))|^$|^\s$)$')])],
			DIACHI: ['', Validators.compose([Validators.required,Validators.maxLength(200)])],
			LOAIKH: ['',Validators.required],
			TINH: ['',Validators.required]
		});

		let controls = this.ThemKH.controls;
		controls['MAKH'].disable();
	}
	//#endregion Tạo form

	//#region Tạo mã tự động
	createCodeAuto(){
		let d = new Date();
		return 'KH'+moment(d).format("YYMMDDhhmmss").toString();
	}
	//#endregion Tạo mã tự động
	
	//#region Function call focus
	validateInvalidForm(isAddDetail: boolean = false){
		const controls = this.ThemKH.controls;
		if (this.ThemKH.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			if (invalidElements.length > 0) {
				for(let i = 0; i < invalidElements.length; i++){
					if(invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT'){
						const elementControl = this.ThemKH.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if(elementControl){
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>{
				controls[controlName].markAsTouched()
			});
			
			return false;
		}

		if(!isAddDetail){
			this.forcusAnotherEmptyField(controls);
		}
		return true;
	}

	forcusAnotherEmptyField(control: any){
		let run : boolean = true;
		Object.keys(control).forEach(controlName =>{

			if((control[controlName].value == null || control[controlName].value == undefined
							|| control[controlName].value == '') && run){

				if(controlName == 'NGUOIDAIDIEN'){
					setTimeout(() => this.focusNLH.first.nativeElement.focus(), 0);
					run = false;
					this.changeDetect.detectChanges();
				}
				if(controlName == 'DIENTHOAI'){
					setTimeout(() => this.focusDT.first.nativeElement.focus(), 0);
					run = false;
					this.changeDetect.detectChanges();
				}
				if(controlName == 'DIACHI'){
					setTimeout(() => this.focusDC.first.nativeElement.focus(), 0);
					run = false;
					this.changeDetect.detectChanges();
				}
			}
		});
	}
	//#endregion Function call focus

	//#region Gui data sang api
	onSubmit() {
		const controls = this.ThemKH.controls;
		/** check form */
		if (this.ThemKH.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			if (invalidElements.length > 0) {
				for(let i = 0; i < invalidElements.length; i++){
					if(invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT'){
						const elementControl = this.ThemKH.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if(elementControl){
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}


			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		const form = new KhachHangModelLite();
		form.clear();
		form.MaKH = controls['MAKH'].value;
		form.TenKH = controls['TENKH'].value;
		form.NguoiDaiDien = controls['NGUOIDAIDIEN'].value;
		form.DienThoai = controls['DIENTHOAI'].value;
		form.DiaChi = controls['DIACHI'].value;
		form.IdLoai = +controls['LOAIKH'].value;
		form.IdTinh = +controls['TINH'].value;

		this.kdYCBGService.setKH(form).subscribe(res =>{
			if(res && res.status === 1){
				this.isChange = true;
				this.dataRespone = res.data;
				const message = `Thêm mới khách hàng thành công.`;
				this.layoutUtilsService.showInfo(message);
				this.back();
			}else{
				this.layoutUtilsService.showErorr(res.error.message);
			}
		})
	}
	//#endregion Gui data sang api

	getTitle(): string {
		return `THÊM NHANH KHÁCH HÀNG `;
	}

	createAutoKH(){
	var controls= this.ThemKH.controls;
		this.DungChungService.getBillNumber(this.category_path).subscribe(res=>{
			if(res&&res.status==1){
				
				controls['MAKH'].setValue(res.data);
				this.changeDetect.detectChanges();
			}else{
				this.layoutUtilsService.showErorr(res.error.message);
			}
		})
	}

	

}

